<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  current: number
  total: number
}>()

const progress = computed(() => (props.current + 1) / props.total)
const percentage = computed(() => progress.value * 100 + '%')
</script>

<template>
  <div class="relative h-1 overflow-visible bg-transparent">
    <div
      class="fill absolute inset-0 z-[2] origin-left bg-[linear-gradient(90deg,#52b7b9,#3783b0)] transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]"
      :style="{ transform: `scaleX(${progress})` }"
    />
    <div
      class="glow-clip pointer-events-none absolute left-0 top-0 z-[1] h-5 overflow-hidden transition-[width] duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]"
      :style="{ width: percentage }"
    >
      <div class="absolute -right-10 top-px flex h-8 w-40 rotate-180 items-end overflow-hidden">
        <div class="-mb-px flex h-1 w-full rotate-180">
          <div class="glow-soft w-full flex-none" />
          <div class="glow-sharp ml-[-100%] w-full flex-none" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.glow-soft {
  filter: blur(8px);
  background-image: linear-gradient(
    -90deg,
    rgba(0, 145, 146, 0) 0%,
    #009192 32%,
    rgba(0, 145, 146, 0.3) 67%,
    rgba(0, 145, 146, 0) 100%
  );
}

.glow-sharp {
  filter: blur(1px);
  background-image: linear-gradient(
    90deg,
    rgba(0, 145, 146, 0) 0%,
    #009192 32%,
    rgba(0, 145, 146, 0.3) 67%,
    rgba(0, 145, 146, 0) 100%
  );
}

@media (prefers-reduced-motion: reduce) {
  .fill,
  .glow-clip {
    transition: none;
  }
}
</style>
